"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFunctionBot = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const constants_1 = require("../component/constants");
const workflow_1 = require("../component/workflow");
function hasFunctionBot(projectSettings) {
    const botComponent = workflow_1.getComponent(projectSettings, constants_1.ComponentNames.TeamsBot);
    if (!botComponent)
        return false;
    return botComponent.hosting === constants_1.ComponentNames.Function;
}
exports.hasFunctionBot = hasFunctionBot;
//# sourceMappingURL=projectSettingsHelperV3.js.map